import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  noIndex?: boolean;
}

const defaultTitle = 'OMECAP Hub - Hệ thống quản lý phòng khám và đơn thuốc';
const defaultDescription = 'OMECAP Hub - Giải pháp quản lý phòng khám, đơn thuốc quốc gia, hóa đơn điện tử toàn diện. Tối ưu quy trình khám chữa bệnh, liên thông dữ liệu y tế.';
const defaultKeywords = 'quản lý phòng khám, đơn thuốc quốc gia, ĐTQG, hóa đơn điện tử, phần mềm y tế, omecap, quản lý bệnh nhân, kê đơn thuốc';
const siteUrl = 'https://hub.omecap.com';

const SEO: React.FC<SEOProps> = ({
  title,
  description = defaultDescription,
  keywords = defaultKeywords,
  canonical,
  ogImage = '/og-image.png',
  noIndex = false,
}) => {
  const fullTitle = title ? `${title} | OMECAP Hub` : defaultTitle;
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Canonical URL */}
      <link rel="canonical" href={fullCanonical} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="vi_VN" />
      <meta property="og:site_name" content="OMECAP Hub" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />
    </Helmet>
  );
};

export default SEO;
